<template>
  <div :class="`info-window ${infoWindowVisible}`">
    <div class="info-window-content-wrapper">
    <div class="info-window-content">
    <!-- <button v-on:click="closeInfoWindow">閉じる</button> -->
      <div class="popup">
        <div class="left-block">
          <h1 class="popup_title">{{ selectedMarker.name }}</h1>
          <p v-html="selectedMarker.address" class="popup_address"></p>
          <!-- 円グラフ -->
          <pie-chart :info="info" />
        </div>
        <!-- population -->
        <div v-if="selectedDataType===1" class="right-block">
          <pop-table :info="info" />
        </div>
        <!-- end population -->
        <!-- household -->
        <div v-else class="right-block">
          <house-table :info="info" />
        </div>
        <!-- end household -->
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  // TODO: infoWindowをマーカーの真上に表示するようにする
  import popTable from '@/components/popTable'
  import houseTable from '@/components/houseTable'
  import pieChart from '@/components/pieChart'
  import { markRaw } from 'vue'
  import L from 'leaflet'
  import axios from 'axios'
  import _env from '../../config/dev.env.var'
  
  export default {
    name: 'linfoWindow',
    components: {
      popTable,
      houseTable,
      pieChart
    },
    data: function() {
      return {
        info: {},
        latlon: null,
        markerName: null,
        latlng: null,
        radius: 500, // meter
        infoWindowLoaded: false,
      }
    },
    mounted() {
    },
    methods: {
      // infoWindow用の人口データを取得
      async fetchAgePopulation() {
        this.$store.commit('chgLoadingModalVisible', true)
        await axios.get(`${_env.fastAPI}/infoWindow`, {
          params: {
            year: this.year,
            range: this.circleRange,
            lat: this.latlon[0],
            lon: this.latlon[1] 
          }
        })
        .then(res => {
          this.info = res.data
          this.$store.commit("chgLoadingModalVisible",false)
          this.infoWindowLoaded = true
        })
      },
      closeInfoWindow() {
        this.$store.commit('chgInfoWindowVisible', false) // close InfoWindow
        if (this.sharedState.circle != null) {
          this.$store.commit('removeLayer', this.sharedState.circle);
          this.$store.commit('setCircle', null);
        }
        this.infoWindowLoaded = false
      },

      fetchInfo(){
        this.fetchAgePopulation()
      }
    },
    computed: {
      sharedState () {
        return this.$store.state
      },
      selectedMarker() {
        return this.sharedState.selectedMarker
      },
      selectedDataType() {
        return this.sharedState.selectedDataType
      },
      circleRange () {
        return this.sharedState.circleRange
      },
      infoWindowVisible () {
        return this.sharedState.infoWindowVisible ? '': 'hidden'
      },
      infoWindowCoord () {
        return this.sharedState.infoWindowCoord
      },
      year () {
        return this.sharedState.year
      },
      mapClickEvent () {
        return this.sharedState.mapClickEvent
      }
    },
    watch: {
      selectedDataType () {
        this.latlon = [this.selectedMarker.lat, this.selectedMarker.lon]
        this.fetchInfo()
      },
      selectedMarker() {
        this.latlon = [this.selectedMarker.lat, this.selectedMarker.lon]
        this.fetchInfo()
      },
      circleRange() {
        this.latlon = [this.selectedMarker.lat, this.selectedMarker.lon]
        this.fetchInfo()
      },
      year() {
        this.latlon = [this.selectedMarker.lat, this.selectedMarker.lon]
        this.fetchInfo()
      },
      mapClickEvent(e) {
        if (!e) {
          return
        }
        if (this.infoWindowLoaded == true) {
          this.closeInfoWindow()
        }else{
          this.$store.commit('setSelectedMarker', {
            name: "", // TODO 地点情報を表示する
            address: "緯度: "+e.latlng.lat+"　経度"+e.latlng.lng,
            lat: e.lat,
            lon: e.lng,
            category: ""
          })

          // TODO:サークル描画．描画が上手く走らない
          // クリック時にマーカーの下にサークルを描画
          const circle = markRaw(L.circle([e.lat, e.lng], parseInt(this.sharedState.circleRange)));
          this.$store.commit('addLayer', circle)
          this.$store.commit('setCircle', circle)

          this.$store.commit('chgInfoWindowVisible', true)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.info-window {
  z-index: 30;
  position: absolute;
  top: 80px;
  left: 250px;
  right: 0;
  background: #fff;
  width: 80%;
  max-width: 700px;
  min-width: 700px;
  padding: 30px;
  border-radius: 4px;
  margin: 0 auto;
  height: 400px;
}
.info-window.hidden {
  display: none;
}
.info-window-content-wrapper{
  position: relative;
}
.info-window-content {
  position: absolute;
  height: 80%;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin: 0 auto;
  padding: 0;
}
.pop-table table {
  width: 100%;
}
.house-table {
  padding-bottom: 20px;
}
.right-block {
  position: relative;
  width: 50%;
}
.left-block {
  position: relative;
  width: 40%;
  margin: 0px;
}
</style>

